import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api.service';
declare var window;

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent implements OnInit {

  urlParam : any;
  msg : string = '';
  userData:any;
  tranData:any;
  bookingId :any; 
  dataLayer:Array<any> =[];
  constructor(public route:ActivatedRoute, public httpService: ApiService, public globalService:GlobalService ) { }

  ngOnInit() {
    this.route.params.subscribe(param=>{
      this.urlParam = param; 
   });

    this.route.queryParams.subscribe( res => {
      this.bookingId = res;
      console.log(this.bookingId);
    })  
    this.payInfo();
  }
  payInfo(){
    let Url = "/viewOrder/" + (this.bookingId.bookinId?this.bookingId.bookinId:'');
    this.httpService.getDatabill(Url).subscribe(response => {
    this.tranData = [{
      orderId:response[0]['bookingInfo'][0]['orderId'],
      price:response[0]['bookingInfo'][0]['price'],
      transactionId:response[0]['bookingInfo'][0]['transactionId']

    }];
    if (this.globalService.isBrowser && this.tranData['orderId']) {
      setTimeout(() => {
        this.demo()

      }, 100);
    }
  });
  }

  // demo(){      
  //   window.dataLayer = window.dataLayer || [];  
  //    window['dataLayer'].push({
  //  'event':'orderCompleteNow',
  //  'transactionId': this.tranData && this.tranData.orderId ? this.tranData.orderId:'', 
  //  'transactionTotal': this.tranData && this.tranData.price ? this.tranData.price:'', 
  //  'transactionProducts': [{
  //    'sku': this.tranData && this.tranData.itinerary && this.tranData.itinerary.programSlug  ? this.tranData.itinerary.programSlug : '',
  //    'name': this.tranData && this.tranData.itinerary && this.tranData.itinerary.programName  ? this.tranData.itinerary.programName : '',
  //    'category': this.tranData && this.tranData.itinerary && this.tranData.itinerary.categoryName  ? this.tranData.itinerary.categoryName : '',
  //    'price': this.tranData && this.tranData.price ? this.tranData.price:'',  
  //    'quantity': 1 
  //  }]
  // });
  // }

  demo(){
    window.dataLayer.push({
      'event':'orderCompleteNow',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': this.tranData && this.tranData.orderId ? this.tranData.orderId:'',                         // Transaction ID. Required for purchases and refunds.
            'affiliation': '',
            'revenue': '',                     // Total transaction value (incl. tax and shipping)
            'tax':'',
            'shipping': '',
            'coupon': ''
          },
          'products': [{                            // List of productFieldObjects.
            'name': this.tranData && this.tranData.itinerary && this.tranData.itinerary.programName  ? this.tranData.itinerary.programName : '',     // Name or ID is required.
            'id': this.tranData && this.tranData.orderId ? this.tranData.orderId:'',
            'price': this.tranData && this.tranData.price ? this.tranData.price:'', 
            'brand': 'Mytripwell',
            'category':  this.tranData && this.tranData.itinerary && this.tranData.itinerary.categoryName  ? this.tranData.itinerary.categoryName : '',
            'variant': '',
            'quantity': 1,
            'coupon': ''                            // Optional fields may be omitted or set to empty string.
           }
        ]
        }
      }
    });
}

}
